import type { BridgeCallout, Posting } from '../../types.js'

/**
 * The Clinical Bridge callout out for an open seat (26 October 2026): the one the seat is marked with on the board,
 * or, before the board's next read marks it, the one opened for it. Null when none is.
 */
export function calloutForPosting(posting: Pick<Posting, 'postingId'> & { calloutId?: string | null }, callouts: readonly BridgeCallout[] | undefined): BridgeCallout | null {
  if (!callouts) {
    return null
  }
  return callouts.find((callout) => (posting.calloutId ? callout.calloutId === posting.calloutId : callout.postingId === posting.postingId)) ?? null
}

/** The callout in a line, as the seat's row says it: told, declined, taken, run out or withdrawn. */
export function calloutLine(callout: BridgeCallout, nameOf: (workerId: string) => string): string {
  const declined = callout.responses.filter((response) => response.answer === 'decline').length
  switch (callout.status) {
    case 'open':
      return `Bridge callout out · ${callout.pool.length} told${declined > 0 ? ` · ${declined} declined` : ''}`
    case 'filled':
      return `Bridge callout taken by ${callout.filledBy ? nameOf(callout.filledBy.workerId) : 'a worker'}`
    case 'expired':
      return 'Bridge callout ran out unanswered'
    case 'cancelled':
      return 'Bridge callout withdrawn'
  }
}
